import { PortalLandingPageType } from '@common-lib';

import { routes } from './routes';

export const publicLandingNavigation = (homeEnabled: boolean) => {
  if (homeEnabled) {
    return routes.home;
  }

  return routes.welcome;
};

export const privateLandingNavigation = (
  landingPage: PortalLandingPageType | undefined,
  homeEnabled: boolean,
) => {
  switch (landingPage) {
    case 'WALLET':
      return routes.wallet.list();
    case 'SITE_UNIT_LIST':
      return routes.siteUnits.sites;
    case 'HOME':
      return homeEnabled ? routes.home : routes.wallet.list();
    default:
      return routes.wallet.list();
  }
};
